import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CheckBoxTable} from "../../models/table.model";
import {CheckboxTableService} from "../../services/checkbox-table.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-checkbox-table',
  templateUrl: './checkbox-table.component.html',
  styleUrls: ['./checkbox-table.component.scss']
})
export class CheckboxTableComponent implements OnInit, OnDestroy {
  @Input() item!: CheckBoxTable
  @Output() changeItem: EventEmitter<CheckBoxTable> = new EventEmitter<CheckBoxTable>

  subs: Subscription[] = []

  constructor(
    private checkboxTableService: CheckboxTableService
  ) {
  }

  ngOnInit() {
    this.subs.push(this.checkboxTableService.checkboxSelectAll$.subscribe({
      next: (res) => {
        this.item.state = res
      }
    }))
  }

  ngOnDestroy() {
    this.subs.forEach(item => item.unsubscribe())
  }

  checkChange(item: CheckBoxTable) {
    this.changeItem.emit(item)
  }
}
